module.exports = __webpack_public_path__ + "static/img/disclaimer-300x300.b1d140a8.gif";